import { useContext, createContext, useState } from 'react';

const MainContext = createContext();

export const MainAppProvider = ({ children }) => {
  let [openModalFromSaved, setOpenModalFromSaved] = useState(false);
  return (
    <MainContext.Provider
      value={{
        openModalFromSaved,
        setOpenModalFromSaved,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export const NewMainContext = () => {
  return useContext(MainContext);
};
